module.exports = __webpack_public_path__ + "static/media/image_logo_qinqin_color.edae3bd2.png";